import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PaymentService } from '../../../services/payment.service';
import { ParameterService } from '../../../services/parameter.service';
import { environment } from '../../../../environments/environment';
import { Payment } from '../../../models/payment';
import { NuveiCheckoutModalComponent } from './nuvei-checkout-modal/nuvei-checkout-modal.component';

declare var document: any;

@Component({
  selector: 'app-nuvei-checkout',
  templateUrl: './nuvei-checkout.component.html',
  styleUrls: ['./nuvei-checkout.component.css']
})

export class NuveiCheckoutComponent implements OnInit {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;
  @Input() allowCardSaving: boolean;
  @Input() forceCardSaving: boolean;
  @Input() defaultCardSaving: boolean;

  @Output() paymentSucces: EventEmitter<any> = new EventEmitter();
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;

  private apiURL = environment.apiURL;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private parameterService: ParameterService,
    private paymentService: PaymentService, public dialog: MatDialog) { }

    ngOnInit() {
        this.loading = false;
    }

    clickPayment() {
        this.loading = true;
        this.paymentService.getPayment(this.paymentToken, this.chamberId, true)
        .then((payment: Payment) => {
            this.loading = false;
            payment.NuveiCheckout.AllowCardSaving = this.allowCardSaving;
            payment.NuveiCheckout.ForceCardSaving = this.forceCardSaving;
            payment.NuveiCheckout.DefaultCardSaving = this.defaultCardSaving;
            //Show pop-up with nuvei hpp
            const dialogRef = this.dialog.open(NuveiCheckoutModalComponent, {
                width: '650px',
                data: payment.NuveiCheckout
            });

            dialogRef.afterClosed().subscribe((data: any) => {
                if (data) {
                    this.checkoutCallback(data);
                }
            });
        })
        .catch((error) => {
            this.loading = false;
            this.paymentError.emit(error);
        });
    }

    checkoutCallback(data: any) {
        if (!(data && data.info && data.result)) {
            this.paymentError.emit('error');
            this.loading = false;
            return;
        }

        this.loading = true;
        this.postNuveiPayment(this.chamberId, this.paymentToken, data.info.SessionToken)
        .then(() => {
            this.loading = false;
            this.paymentSucces.emit(null);
        })
        .catch((reterror) => {
            this.loading = false;
            this.paymentError.emit(reterror);
        });
    }

    public postNuveiPayment(chamberId: string, paymentToken: string, sessionToken: string): Promise<any> {
        let callbackUrl = this.apiURL + 'payment/' + sessionToken + '/nuvei/' + '?chamberid=' + chamberId + '&paymenttoken=' + paymentToken;

        if (this.source && this.source.trim() !== '') {
            callbackUrl += '&paymentsource=' + this.source;
        }
        if (this.userId && this.userId.trim() !== '') {
            callbackUrl += '&userid=' + this.userId;
        }

        const callHeaders: HttpHeaders = this.headers;
        return this.http.post<any>(callbackUrl, null, {headers: callHeaders})
        .toPromise()
        .then(response => response)
        .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.error || error.message || error);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/nuvei-checkout/nuvei-checkout.component.ts